// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    display: flex;
    justify-content: space-between;
    align-items: center; /* ← Centra verticalmente logo y botón */
    padding: 48px 160px;
    background: #111111;
}

.login-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
}

.header-container {
    display: flex;
    align-items: center;
    flex-grow: 1;
    width: auto;
    object-fit: contain;
}

.lovify_logo {
    width: auto;
    height: 110px;
    object-fit: contain;
}

.brand {
    font-size: 60px;
    font-weight: bold;
    color: white;
}

.login-button-header {
    background: #ffffff;
    color: black;
    font-weight: bold;
    font-size: 28px;
    border: none;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    width: 275px;
    height: 90px;
    padding: 14px 32px;
    cursor: pointer;
    transition: background 0.3s;
}

.button-container {
    display: flex;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/landing_header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB,EAAE,wCAAwC;IAC7D,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center; /* ← Centra verticalmente logo y botón */\n    padding: 48px 160px;\n    background: #111111;\n}\n\n.login-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.header-container {\n    display: flex;\n    align-items: center;\n    flex-grow: 1;\n    width: auto;\n    object-fit: contain;\n}\n\n.lovify_logo {\n    width: auto;\n    height: 110px;\n    object-fit: contain;\n}\n\n.brand {\n    font-size: 60px;\n    font-weight: bold;\n    color: white;\n}\n\n.login-button-header {\n    background: #ffffff;\n    color: black;\n    font-weight: bold;\n    font-size: 28px;\n    border: none;\n    align-items: center;\n    justify-content: center;\n    border-radius: 999px;\n    width: 275px;\n    height: 90px;\n    padding: 14px 32px;\n    cursor: pointer;\n    transition: background 0.3s;\n}\n\n.button-container {\n    display: flex;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
